export enum EnumSubTipoElemLog {
  INF_RT = 1,
  INF_GNL = 2,
  INF_AASS = 3,
  PTO_PCPR = 4,
  PTO_PCDB = 5,
  PTO_PCCC = 6,
  PTO_PCAS = 7,
  PTO_PCI = 8,
  PTO_PCY = 9,
  PTO_PCTD = 10,
  PTO_PCDD = 11,
  PTO_PCLD = 12,
  PTO_PS = 13,
  PTO_PE = 14,
  POS_PCPR = 15,
  POS_PCDB = 16,
  POS_PCCC = 17,
  POS_PCAS = 18,
  POS_PCI = 19,
  POS_PCY = 20,
  POS_PCTD = 21,
  POS_PCDD = 22,
  POS_PCLD = 23,
  POS_PS = 24,
  POS_PE = 25,
  OTR_PO = 26,
  OTR_PSAT = 27,
  OTR_PF = 28,
  PTO_PPBD = 29,
  PTO_PCPF = 30,
  OTR_RT = 31,
  OTR_RD = 32,
  OTR_SP = 33,
  OTR_BK = 34,
  OTR_FI = 35,
  INF_PSAT = 36
}
